import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createPortal } from 'react-dom';
import isServer from 'commons/isServer';
import IconClose from 'components/icons/iconClose';
import { colorWhite } from 'styles/layout/colors';
import withBrowserOnly from 'components/hoc/withBrowserOnly';
const SnackbarRootElement = !isServer() ? document.getElementById('Snackbar-root') : null;
const Snackbar = t0 => {
  const $ = _c(17);
  const {
    children,
    isOpen,
    onClose
  } = t0;
  const t1 = !isOpen;
  let t2;
  if ($[0] !== isOpen || $[1] !== t1) {
    t2 = classNames("bottom-0 justify-center left-0 pt-0 px-4 pb-4 right-0 fixed transition-[opacity_.2s_ease-in-out]", {
      "hidden opacity-0": t1,
      "flex opacity-100": isOpen
    });
    $[0] = isOpen;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isOpen) {
    t3 = classNames("text-xs bg-brand-dark [background-image:url(https://joybird2.imgix.net/user-uploads-staging/joybird-teal-new.jpg?w=400&cs=srgb)] bg-cover font-bold items-center rounded text-white flex", {
      "Snackbar--isOpen": isOpen
    });
    $[3] = isOpen;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children) {
    t4 = <div className="pt-3 pr-0 pb-3 pl-5">{children}</div>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconClose color={colorWhite} height={10} width={10} />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== onClose) {
    t6 = <button className="[background:none] border-0 pt-3 pr-5 pb-3 pl-4 hover:cursor-pointer" onClick={onClose} type="button">{t5}</button>;
    $[8] = onClose;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t2 || $[15] !== t7) {
    t8 = createPortal(<div className={t2}>{t7}</div>, SnackbarRootElement);
    $[14] = t2;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
Snackbar.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired
};
export default withBrowserOnly(Snackbar);